import { TIMEOUT_TIME, STAGE_DIRNAME, BASE_PATH_API_DEV, BASE_PATH_API } from 'constants/general';
import axios from 'axios';
import { decodeStorage } from 'functions/storageBase64';

//post enviar Nip
export async function postNipIncode(data) {

    const access_token = decodeStorage('access_token')
    
    console.log("data-nip:",data);

    let apiURL;
    
    if(STAGE_DIRNAME === "dev"){
        apiURL = `${BASE_PATH_API_DEV.creditoServices}/sol-claro/solicitudes-claro/v1/valida-Nip`
    }else{
        apiURL = `${BASE_PATH_API}/sol-claro/solicitudes-claro/v1/valida-Nip`
    }

    const raw = data;

    const config = {
        method: 'post',
        url: apiURL,
        timeout: TIMEOUT_TIME,
        withCredentials: false,
        headers: {
            'Authorization': `Bearer ${access_token}`,
            'Content-Type': 'application/json; charset=utf-8'
        },
        data: raw
    };

    return await axios(config)
        .then(res => {
            const {
                headers,
                status,
                data
            } = res
            console.log("postNip:",data);
            return {
                'headers': headers,
                'statusCode': status,
                'data': data,
                'error': ''
            }
        })
        .catch(error => {
            return {
                'headers': '',
                'statusCode': error?.request?.status,
                'data': error?.response?.data,
                'error': error?.response?.data?.codMen
            }
        })
}
